import { Modal } from "../../Modal";
import React from "react";
import alertIcon from "../../../assets/images/alert.svg";
import { FormattedMessage, useIntl } from "react-intl";
import { Form, Select, Space } from "antd";

export default function UpdateWebhookKeyModal({
  open, onCancel, onSubmit, environment, environment_label }) {

  const intl = useIntl()

  const [date, setDate] = React.useState("1")

  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={onCancel}
        title={intl.formatMessage({
          id: "page.integration.webhook.modal.title",
        })
        }
      />
      <Modal.Content align={"start"}>
        <Modal.Icon>
          <img alt="Alert" src={alertIcon} />
        </Modal.Icon>
        <Space direction="vertical">
          <h1 className="text-md text-gray-700">
            <FormattedMessage
              id="page.integration.webhook.modal.description"
              values={{ environment: environment_label }}
            />
          </h1>
          {environment === 'production' && (
            <>
              <h1 className="text-sm text-gray-600">
                <FormattedMessage id="page.integration.capture.modal.label" />
              </h1>
              <Form layout="vertical">
                <Form.Item required extra={
                  intl.formatMessage({
                    id: "page.integration.capture.modal.label.description",
                  })

                }>
                  <Select
                    size="large"
                    defaultValue={date}
                    value={date}
                    onChange={(value) => setDate(value)}
                  >
                    <Select.Option value="1">
                      <FormattedMessage id="page.integration.capture.modal.label.1" />
                    </Select.Option>
                    <Select.Option value="7">
                      <FormattedMessage id="page.integration.capture.modal.label.7" />
                    </Select.Option>
                    <Select.Option value="30">
                      <FormattedMessage id="page.integration.capture.modal.label.30" />
                    </Select.Option>
                    <Select.Option value="0">
                      <FormattedMessage id="page.integration.capture.modal.label.0" />
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Form>
            </>
          )}
        </Space>
      </Modal.Content>
      <Modal.Actions
        submitText={
          intl.formatMessage({ id: "confirm" })
        }
        onSubmitAction={() => onSubmit(date)}
        onCancelAction={onCancel}
      />
    </Modal.Root>
  );
}
